import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import Header from './components/Header';
import Footer from './components/Footer';
import HomePage from './pages/HomePage';
import ProductsPage from './pages/ProductsPage';
import ProductDetailPage from './pages/ProductDetailPage';
import CategoryPage from './pages/CategoryPage';
import SubcategoryPage from './pages/SubcategoryPage';
import SearchPage from './pages/SearchPage';
import GuidesIndexPage from './pages/GuidesIndexPage';
import GuideDetailPage from './pages/GuideDetailPage';
import TechnologyPage from './pages/TechnologyPage';
import AnalyticsPage from './pages/AnalyticsPage';
import { trackPageView } from './utils/telemetry';

// Automatically track page views on route changes
const RouteTracker: React.FC = () => {
  const location = useLocation();

  useEffect(() => {
    trackPageView(location.pathname + location.search);
    window.scrollTo(0, 0);
  }, [location]);

  return null;
};

function App() {
  return (
    <HelmetProvider>
      <Router>
        <RouteTracker />
        <div className="min-h-screen bg-gray-50 flex flex-col justify-between">
          <Header />
          <main className="flex-1">
            <Routes>
              <Route path="/" element={<HomePage />} />
              <Route path="/products" element={<ProductsPage />} />
              <Route path="/products/:slug" element={<ProductDetailPage />} />
              <Route path="/category/:slug" element={<CategoryPage />} />
              <Route path="/subcategory/:slug" element={<SubcategoryPage />} />
              <Route path="/guides" element={<GuidesIndexPage />} />
              <Route path="/guides/:slug" element={<GuideDetailPage />} />
              <Route path="/search" element={<SearchPage />} />
              <Route path="/technology" element={<TechnologyPage />} />
              <Route path="/admin/analytics" element={<AnalyticsPage />} />
              <Route path="/admin/telemetry" element={<AnalyticsPage />} />
            </Routes>
          </main>
          <Footer />
        </div>
      </Router>
    </HelmetProvider>
  );
}

export default App;
